(ns frontend.view.modals.session-timeout.view
  (:require
   [common.localization :as loc]
   [frontend.view.modals.session-timeout.events :as events]
   [frontend.bootstrap.components :as rbs]
   [frontend.conn :as conn]
   [frontend.utils :as fu]
   [ui.components.modal.view :as modal]))

(defonce modal-key :session-timeout-modal)

(defn view
  [{:keys [shown? close-modal! state class-name topmost?]}]
  (let [expires-in (or (:expires-in @state)
                       (events/track-time! state))
        on-close! (fn [_]
                    (events/stop-tracker! state)
                    (close-modal!))]
    (events/start-tracker! state)
    (fn [{:keys [shown? close-modal! state class-name topmost?]}]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         on-close!
        :backdrop      "static"
        :close-button? true}
       (loc/tr :attention)
       [:p.zap-modal__body__row.text-center
        (if (> expires-in 0)
          (loc/tr :session-timeout-warning [(Math/floor (/ expires-in 1000))])
          (loc/tr :session-timed-out))]
       [modal/right-single-button
        nil
        false
        (fn [_]
          (events/stop-tracker! state)
          (conn/refresh-session!)
          (close-modal!))
        (loc/tr :session-timeout-refresh-button)
        nil]])))
